module.exports = __webpack_public_path__ + "static/media/icevi.9bd8a82e.png";